enum DrawerDirections {
  RIGHT = 'right',
  BOTTOM = 'bottom',
  FULLHEIGHT = 'full-height',
}
enum DrawerOpenAt {
  DEFAULT = 'default',
  AVAILABLE_HEIGHT = 'available-height',
}
export { DrawerDirections, DrawerOpenAt };
